import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Divider, Typography } from '@mui/material';
import { ButtonAction, TitleButton } from './style';
import { ReactComponent as Check } from '../../assets/icons/Check.svg';
import { ReactComponent as Xmark } from '../../assets/icons/Xmark.svg';
import CheckText from '@atoms/CheckText/CheckText';

interface Props {
  handleClickClose: () => void;
  open: boolean;
}
export default function DialogHint({ handleClickClose, open }: Props) {
  const descriptionElementRef = React.useRef<HTMLElement>(null);

  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  return (
    <Dialog
      sx={{
        backdropFilter: 'blur(4px)',
        backgroundColor: 'rgba(92, 89, 92, 0.88)',
      }}
      open={open}
      onClose={handleClickClose}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
    >
      <DialogTitle id="scroll-dialog-title">
        Quelques astuces avant de commencer
        <Typography sx={{ paddingBlock: '16px' }}>
          Appliquez ces conseils pour valider votre CV Vidéo.
        </Typography>
        <Divider />
      </DialogTitle>
      <DialogContent
        sx={{
          height: '55vh',
        }}
      >
        <DialogContentText
          id="scroll-dialog-description"
          sx={{
            color: '#1D1D1D',
            fontFeatureSettings: "'clig' off, 'liga' off",
            fontFamily: 'Inter',
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: '400',
            lineHeight: '24px',
          }}
          tabIndex={-1}
        >
          <Box
            sx={{
              background: '#F7EDF4',
              height: '200px',
            }}
          >
            <Typography
              sx={{
                fontSize: '16px',
                fontWeight: '700',
                gap: '8px',
                marginInline: '8px',
                paddingBlock: '16px',
                paddingInline: '8px',
              }}
            >
              A FAIRE
            </Typography>
            <CheckText
              label="Lorem ipsum dollar Lorem ipsum dollar"
              icon={<Check />}
            />
            <CheckText
              label="Lorem ipsum dollar Lorem ipsum dollar"
              icon={<Check />}
            />
            <CheckText
              label="Lorem ipsum dollar Lorem ipsum dollar"
              icon={<Check />}
            />
          </Box>
          <Box
            sx={{
              background: '#F7EDF4',
              height: '200px',
              marginTop: '24px',
            }}
          >
            <Typography
              sx={{
                fontSize: '16px',
                fontWeight: '700',
                gap: '8px',
                marginInline: '8px',
                paddingBlock: '16px',
                paddingInline: '8px',
              }}
            >
              A Eviter
            </Typography>

            <CheckText
              label="Lorem ipsum dollar Lorem ipsum dollar"
              icon={<Xmark />}
            />
            <CheckText
              label="Lorem ipsum dollar Lorem ipsum dollar"
              icon={<Xmark />}
            />
            <CheckText
              label="Lorem ipsum dollar Lorem ipsum dollar"
              icon={<Xmark />}
            />
          </Box>
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <ButtonAction onClick={handleClickClose}>
          <TitleButton>Commencer</TitleButton>
        </ButtonAction>
      </DialogActions>
    </Dialog>
  );
}
